// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.impact-map-header {
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 220px;
}

ion-toolbar {
  --min-height: 60px;
  height: 60px;
  display: flex;
  align-items: center;
}

.headerIconBackground {
  background-color: var(--ion-color-secondary);
  height: 36px;
  width: 36px;
  font-size: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.impact-map-header-left {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.impact-map-header-center {
  flex: 2;
  display: flex;
  justify-content: space-evenly;
}

.impact-map-header-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.header-icon {
  font-size: 24px;
}

@media only screen and (max-width: 1920px) {
  .height ion-toolbar {
    --min-height: 40px;
    height: 40px;
  }
}
@media only screen and (min-width: 1920px) {
  .height .headerIcon {
    font-size: 26px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
